import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@cak-legacy/shared-common';
import { translate } from '@cak-legacy/klantondersteuning-shared';

export interface IBackToVorigeButtonProps {
  buttonText?: string;
}
export const BackToVorigeButton: React.FC<IBackToVorigeButtonProps> = (props) => {
  const history = useHistory();
  const buttonText = props.buttonText ?? translate('Vorige');

  return <Button layout="secondary" buttonText={buttonText} clickHandler={() => history.goBack()}></Button>;
};
